export const buildCarRentalReservationUrl = (endpoint: string | undefined, reservationId: string, lastName: string) => {
  const params = new URLSearchParams({
    request_id: reservationId,
    surname: lastName,
  })
  const base = endpoint?.replace(/\/$/, '') || ''

  return `${base}/cars/reservation/?${params.toString()}`
}
